import thumbnailQuevedoLaUltima from "../Assets/quevedo-la-ultima.png";
import thumbnailSuicideboysThinGreyLine from "../Assets/suicideboys-thin-grey-line.png";
import thumbnailEminemTobey from "../Assets/eminem-tobey.png";
import thumbnailDenzelCurryStillInThePaint from "../Assets/denzel-curry-still-in-the-paint.png";
import thumbnailDonToliverYeatRendezvous from "../Assets/don-toliver-yeat-rendezvous.png";
import thumbnailBigSeanYes from "../Assets/big-sean-yes.png";
import thumbnailLlCoolJEminemMurdergramDeux from "../Assets/ll-cool-j-eminem-murdergram-deux.png";
import thumbnailNettspendFckSwag from "../Assets/nettspend-fck-swag.png";
import thumbnailKaiCenatMafiathon2 from "../Assets/kai-cenat-mafiathon-2.png";
import thumbnailPoweradeFlaujae from "../Assets/powerade-flaujae.png";
import thumbnailSmirnoffSaweetie from "../Assets/smirnoff-saweetie.png";
import thumbnailNikeTravisScott from "../Assets/nike-travis-scott.png";
import thumbnailCentralCee21SavageGbp from "../Assets/central-cee-21-savage-gbp.png";
import thumbnailKaiCenatBatman from "../Assets/kai-cenat-batman.png";
import thumbnailJustinBieberYukon from "../Assets/justin-bieber-yukon.png";
import thumbnailTwsHeadShouldersKneesAndToes from "../Assets/tws-head-shoulders-knees-and-toes.png";
import thumbnail82majorTrophy from "../Assets/82major-trophy.png";
import thumbnailLilYachtyIanHateMe from "../Assets/lil-yachty-ian-hate-me.png";
import thumbnailDallasMavericks20252026ArenaOpener from "../Assets/dallas-mavericks-2025-2026-arena-opener.png";
import thumbnailLilYachtyEndless from "../Assets/lil-yachty-endless.png";
import thumbnailYeatLyfestyle from "../Assets/yeat-lyfestyle.png";
import thumbnailLilYachtyMurda from "../Assets/lil-yachty-murda.png";
import thumbnailSynergySupergirlSummer from "../Assets/synergy-supergirl-summer.png";
import thumbnailFifaEcho from "../Assets/fifa-echo.png";
import thumbnailAlphaDriveOneOmg from "../Assets/alpha-drive-one-omg.png";
import thumbnailpolymarketMariaSharapova from "../Assets/polymarket-maria-sharapova.png";
import thumbnailyetisoup from "../Assets/yetisoup.png";
import thumbnailEscapeTheAlgorithm from "../Assets/escape-the-algorithm.png";
import thumbnailHardScopeLaunchTrailer from "../Assets/hard-scope-launch-trailer.png";
import thumbnailCardiB from "../Assets/cardib.png";
import thumbnailusher from "../Assets/usher.png";

import GBPgif from "../Assets/videos/GBPgif.mp4";
import bigSeanGif from "../Assets/videos/bigseangif.mp4";
import denzelgif from "../Assets/videos/denzelgif.mp4";
import kaibatmangif from "../Assets/videos/kaibatmangif.mp4";
import laultimagif from "../Assets/videos/laultimagif.mp4";
import mafiathongif from "../Assets/videos/mafiathongif.mp4";
import murdergramgif from "../Assets/videos/murdergramgif.mp4";
import JBgif from "../Assets/videos/jbgif.mp4";
import TWSgif from "../Assets/videos/twsgif.mp4";
import Trophygif from "../Assets/videos/trophygif.mp4";
import lyfestylegif from "../Assets/videos/lyfestylegif.mp4";
import murdagif from "../Assets/videos/murdagif.mp4";
import nettspendgif from "../Assets/videos/nettspendgif.mp4";
import poweradegif from "../Assets/videos/poweradegif.mp4";
import smirnoffgif from "../Assets/videos/smirnoffgif.mp4";
import sdboyzgif from "../Assets/videos/sdboyzgif.mp4";
import tobeygif from "../Assets/videos/tobeygif.mp4";
import travisgif from "../Assets/videos/travisgif.mp4";
import yachty2gif from "../Assets/videos/yachty2gif.mp4";
import yachtyendlessgif from "../Assets/videos/yachty_endless.mp4";
import yeatgif from "../Assets/videos/yeatgif.mp4";
import dallasmavsgif from "../Assets/videos/dallasmavsgif.mp4";
import fifagif from "../Assets/videos/fifagif.mp4";
import synergygif from "../Assets/videos/synergygif.mp4";
import alphadrivegif from "../Assets/videos/alphadrivegif.mp4";
import lewisgif from "../Assets/videos/lewisgif.mp4";
import polymarketgif from "../Assets/videos/polymarketgif.mp4";
import yetisoupgif from "../Assets/videos/yetisoupgif.mp4";
import hardscopegif from "../Assets/videos/hardscopegif.mp4";
import escapethealgorithmgif from "../Assets/videos/escapethealgorithmgif.mp4";
import cardibgif from "../Assets/videos/cardibgif.mp4";
import ushergif from "../Assets/videos/ushergif.mp4";

const videoArray = [
  {
    thumbnailSrc: thumbnailNikeTravisScott,
    gifSrc: travisgif,
    alt: "Travis Scott x Nike",
    videoTitle: "Travis Scott x Nike",
    artistName: "",
    youtubeLink: "https://www.youtube.com/embed/YR1AIdmdD74",
  },
  {
    thumbnailSrc: thumbnailpolymarketMariaSharapova,
    gifSrc: polymarketgif,
    alt: "Polymarket × Maria Sharapova",
    videoTitle: "Polymarket × Maria Sharapova",
    artistName: "",
    youtubeLink: "https://youtube.com/embed/WoFCcC2N1ME",
  },
  {
    thumbnailSrc: "https://img.youtube.com/vi/Zb__Bb_eY4k/maxresdefault.jpg",
    gifSrc: lewisgif,
    alt: "Perplexity x Lewis Hamilton",
    videoTitle: "Perplexity x Lewis Hamilton",
    artistName: "",
    youtubeLink: "https://www.youtube.com/embed/Zb__Bb_eY4k",
  },
  {
    thumbnailSrc: thumbnailyetisoup,
    gifSrc: yetisoupgif,
    alt: "Yeti Soup",
    videoTitle: "Yeti Soup",
    artistName: "Instagram",
    youtubeLink: "https://www.youtube.com/embed/4kwUgd7-KEc",
  },
  {
    thumbnailSrc: thumbnailDallasMavericks20252026ArenaOpener,
    gifSrc: dallasmavsgif,
    alt: "2025-2026 Official Arena Opener",
    videoTitle: "2025-2026 Official Arena Opener",
    artistName: "Dallas Mavericks",
    youtubeLink: "https://www.youtube.com/embed/c1wJce5hpDc",
  },
  {
    thumbnailSrc: thumbnailPoweradeFlaujae,
    gifSrc: poweradegif,
    alt: "Powerade",
    videoTitle: "Powerade x Flau'Jae",
    youtubeLink: "https://player.vimeo.com/video/1065660796",
  },
  {
    thumbnailSrc: thumbnailFifaEcho,
    gifSrc: fifagif,
    alt: "Echo (FIFA World Cup 2026™)",
    videoTitle: "Echo (FIFA World Cup 2026™)",
    artistName: "Daddy Yankee, Shenseea & FIFA Sound",
    youtubeLink: "https://youtu.be/228FtMaq8uY",
  },
  {
    thumbnailSrc: thumbnailJustinBieberYukon,
    gifSrc: JBgif,
    alt: "Justin Bieber - YUKON",
    videoTitle: "YUKON",
    artistName: "Justin Bieber",
    youtubeLink: "https://www.youtube.com/embed/fXivMSJm_kA",
  },
  {
    thumbnailSrc: thumbnailusher,
    gifSrc: ushergif,
    alt: "Usher x Chris Brown Tour",
    videoTitle: "R&B Tour",
    artistName: "Usher × Chris Brown",
    youtubeLink: "https://www.instagram.com/reels/DdCR1tjh8Th/",
  },
  {
    thumbnailSrc: thumbnailCardiB,
    gifSrc: cardibgif,
    alt: "Cardi B Tour",
    videoTitle: "Little Miss Drama Tour",
    artistName: "Cardi B",
    youtubeLink: "https://www.instagram.com/reels/DZ-wFB-vks3/",
  },
  {
    thumbnailSrc: thumbnailEscapeTheAlgorithm,
    gifSrc: escapethealgorithmgif,
    alt: "Escape the Algorithm",
    videoTitle: "Escape the Algorithm",
    artistName: "CLUB",
    youtubeLink: "https://youtube.com/embed/UvFw07ruzVs",
  },
  {
    thumbnailSrc: thumbnailSmirnoffSaweetie,
    gifSrc: smirnoffgif,
    alt: "Smirnoff Spot",
    videoTitle: "Smirnoff Spot",
    artistName: "Saweetie & Complex",
    youtubeLink: "https://www.youtube.com/embed/dIb4f4pqpoQ",
  },
  {
    thumbnailSrc: thumbnailHardScopeLaunchTrailer,
    gifSrc: hardscopegif,
    alt: "HardScope - Launch Trailer",
    videoTitle: "Launch Trailer",
    artistName: "HardScope",
    youtubeLink: "https://youtube.com/embed/5hJMNs",
  },
  {
    thumbnailSrc: thumbnailSynergySupergirlSummer,
    gifSrc: synergygif,
    alt: "SYNERGY: The Drink of Supergirl Summer",
    videoTitle: "The Drink of Supergirl Summer",
    artistName: "SYNERGY",
    youtubeLink: "https://www.youtube.com/embed/bNvOlZJKlxM",
  },
  {
    thumbnailSrc: thumbnailKaiCenatBatman,
    gifSrc: kaibatmangif,
    alt: "Batman Arkham Series Marathon",
    videoTitle: "Batman Arkham Series Marathon",
    artistName: "Kai Cenat",
    youtubeLink: "https://www.youtube.com/embed/QSffs6yKCok",
  },
  {
    thumbnailSrc: thumbnailKaiCenatMafiathon2,
    gifSrc: mafiathongif,
    alt: "Mafiathon",
    videoTitle: "Mafiathon 2 (Official Trailer) ft. Kim Kardashian",
    artistName: "Kai Cenat",
    youtubeLink: "https://www.youtube.com/embed/1VTR0-8jgng",
  },
  {
    thumbnailSrc: thumbnailEminemTobey,
    gifSrc: tobeygif,
    alt: "Tobey",
    videoTitle: "Tobey",
    artistName: "Eminem",
    youtubeLink: "https://youtube.com/embed/CanCZktm0TQ",
  },
  {
    thumbnailSrc: thumbnailLlCoolJEminemMurdergramDeux,
    gifSrc: murdergramgif,
    alt: "Murdergram Deux",
    videoTitle: "Murdergram Deux",
    artistName: "LL COOL J & Eminem",
    youtubeLink: "https://www.youtube.com/embed/50Tl8E0Vvms",
  },
  {
    thumbnailSrc: thumbnailCentralCee21SavageGbp,
    gifSrc: GBPgif,
    alt: "GBP",
    videoTitle: "GBP",
    artistName: "Central Cee & 21 Savage",
    youtubeLink: "https://www.youtube.com/embed/_Cu9Df_9Zvg",
  },
  {
    thumbnailSrc: thumbnailBigSeanYes,
    alt: "Yes",
    videoTitle: "Yes",
    artistName: "Big Sean",
    gifSrc: bigSeanGif,
    youtubeLink: "https://youtube.com/embed/YIgwVgcuwWc",
  },
  {
    thumbnailSrc: thumbnailDonToliverYeatRendezvous,
    gifSrc: yeatgif,
    alt: "Don Toliver & Yeat - Rendezvous",
    videoTitle: "Rendezvous",
    artistName: "Don Toliver & Yeat",
    youtubeLink: "https://www.youtube.com/embed/_yHlFQqFLS0",
  },
  {
    thumbnailSrc: thumbnailLilYachtyIanHateMe,
    gifSrc: yachty2gif,
    previewScale: 1.17,
    previewOrigin: "center top",
    alt: "Lil Yachty & Ian - Hate Me",
    videoTitle: "Hate Me",
    artistName: "Lil Yachty & Ian",
    youtubeLink: "https://www.youtube.com/embed/FjFPy3N2tV4",
  },
  {
    thumbnailSrc: thumbnailAlphaDriveOneOmg,
    gifSrc: alphadrivegif,
    alt: "ALPHA DRIVE ONE - OMG!",
    videoTitle: "OMG!",
    artistName: "ALPHA DRIVE ONE",
    youtubeLink: "https://www.youtube.com/embed/cBfYIb1w1iw",
  },

  {
    thumbnailSrc: thumbnailTwsHeadShouldersKneesAndToes,
    gifSrc: TWSgif,
    alt: "TWS (투어스) - Head Shoulders Knees and Toes",
    videoTitle: "Head Shoulders Knees and Toes",
    artistName: "TWS (투어스)",
    youtubeLink: "https://www.youtube.com/embed/4eAF2boGKaA",
  },
  {
    thumbnailSrc: thumbnailLilYachtyMurda,
    gifSrc: murdagif,
    previewScale: 1.17,
    previewOrigin: "center top",
    alt: "Lil Yachty - Murda",
    videoTitle: "Murda",
    artistName: "Lil Yachty",
    youtubeLink: "https://www.youtube.com/embed/QMnpREa1A98",
  },
  {
    gifSrc: laultimagif,
    thumbnailSrc: thumbnailQuevedoLaUltima,
    alt: "Quevedo",
    videoTitle: "LA ÚLTIMA",
    artistName: "Quevedo",
    youtubeLink: "https://www.youtube.com/embed/AwSFuXm5wxg",
  },
  {
    thumbnailSrc: thumbnail82majorTrophy,
    gifSrc: Trophygif,
    alt: "82MAJOR - TROPHY",
    videoTitle: "TROPHY",
    artistName: "82MAJOR",
    youtubeLink: "https://www.youtube.com/embed/lROE6G2DwFY",
  },
  {
    thumbnailSrc: thumbnailLilYachtyEndless,
    gifSrc: yachtyendlessgif,
    previewScale: 1.17,
    previewOrigin: "right top",
    alt: "Lil Yachty - Endless",
    videoTitle: "Endless",
    artistName: "Lil Yachty",
    youtubeLink: "https://www.youtube.com/embed/kbtHS2xP-Yo",
  },

  {
    thumbnailSrc: thumbnailSuicideboysThinGreyLine,
    gifSrc: sdboyzgif,
    alt: "THE THIN GREY LINE",
    videoTitle: "THE THIN GREY LINE",
    artistName: "$UICIDEBOY$",
    youtubeLink: "https://youtu.be/xmyZHot0Lqc",
  },
  {
    thumbnailSrc: thumbnailDenzelCurryStillInThePaint,
    gifSrc: denzelgif,
    alt: "Still In The Paint",
    videoTitle: "Still In The Paint",
    artistName: "Denzel Curry",
    youtubeLink: "https://youtube.com/embed/B0kJ5Kxqm14",
  },
  {
    thumbnailSrc: thumbnailNettspendFckSwag,
    gifSrc: nettspendgif,
    alt: "F*CK SWAG",
    videoTitle: "F*CK SWAG",
    artistName: "Nettspend",
    youtubeLink: "https://youtube.com/embed/BRfZe0mLcpw",
  },
  {
    thumbnailSrc: thumbnailYeatLyfestyle,
    gifSrc: lyfestylegif,
    alt: "LYFESTYLE: THE ALBUM (Trailer)",
    videoTitle: "LYFESTYLE: THE ALBUM (Trailer)",
    artistName: "Yeat",
    youtubeLink: "https://www.youtube.com/embed/uf2JSk7vlto",
  },
];

export { videoArray };
